import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import {
  adaptVendorsToStore
} from './adapters/vendorAdapter'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listVendors',
    method: 'get',
    url: (params) => `/vendors${buildParamList(params)}`,
    resolver: adaptVendorsToStore
  },
  {
    name: 'getVendor',
    method: 'get',
    url: (params) => `/vendors/${params.vendorId}`
  }
]

export const {
  listVendors,
  getVendor
} = buildServices(CONTENT, services)